export enum UuidType {
  Code,
  Badge,
}
